import { render, staticRenderFns } from "./BookingDetailsComponent.vue?vue&type=template&id=ea126b52&"
import script from "./BookingDetailsComponent.vue?vue&type=script&lang=ts&"
export * from "./BookingDetailsComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports